import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=19e4c04d&"
import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=19e4c04d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports